<template>
  <div class="jobDetail breadcrumbs-absolute aboutUs" :class="{ 'aboutUsPC': $store.state.innerWidth > 768 }">
    <div class="header jobPosingSearch row flexHeader flexHeaderJia200 flexHeader240">
      <Breadcrumbs></Breadcrumbs>
      <div class="warp-mask"></div>
      <div class="job-containers-center col-sm-10 col-md-8 padLeft-0 padRight-0">
        <h1 class="Bold center" :class="{ 'font-size-60': $store.state.innerWidth > 768 }">{{ $t("message.About Human") }}</h1>
      </div>
    </div>
    <div class="opp-contain row">
      <div class="opportunityPC marin-b2-100" style="z-index: 1">
        <div class="descriptionPC-left col-sm-4 col-md-4 padLeft-0 padRight-0">
          <i class="icon-arrow-down mainColor" :class="{ 'arrow-down-rotate': showMenuGroup }" @click="openMenuGroup"></i>
          <div class="row menuLeft showSelect" @click="openMenuGroup">
            <div v-if="select == 1">{{ $t("message.Welcome Talent") }}</div>
            <div v-if="select == 2">{{ $t("message.Membership and Terms of Reference") }}</div>
            <div v-if="select == 3">{{ $t("message.HRPC Information Centre") }}</div>
            <div v-if="select == 4">{{ $t("message.Contact Us") }}</div>
          </div>
          <div class="mask" @click="openMenuGroup" :class="{ 'show': showMenuGroup, 'maskPC': $store.state.innerWidth > 768 }"></div>
          <div class="menuGroup" :class="{ 'SemiBold': $store.state.innerWidth > 768 }" v-if="showMenuGroup || $store.state.innerWidth > 768">
            <div class="row menuLeft" @click="selectEvent(1)" :class="{ 'selectMenu': select == 1 }">
              <a href="javascript:;" style="color: inherit">{{ $t("message.Welcome Talent") }}</a>
            </div>
            <div class="row menuLeft" @click="selectEvent(2)" :class="{ 'selectMenu': select == 2 }">
              <a href="javascript:;" style="color: inherit">{{ $t("message.Membership and Terms of Reference") }}</a>
            </div>
            <div class="row menuLeft" @click="selectEvent(3)" :class="{ 'selectMenu': select == 3 }">
              <a href="javascript:;" style="color: inherit">{{ $t("message.HRPC Information Centre") }}</a>
            </div>
            <div class="row menuLeft" @click="selectEvent(4)" :class="{ 'selectMenu': select == 4 }">
              <a href="javascript:;" style="color: inherit">{{ $t("message.Contact Us") }}</a>
            </div>
          </div>
        </div>
        <div class="descriptionPC-right col-sm-8 col-md-8 padLeft-0 padRight-0">
          <div class="contentGroup padding-b-50">
            <img class="bgImg2" v-if="$store.state.innerWidth <= 1320" src="../images/deco-18.png" />
            <div class="page1" v-if="select == 1">
              <h2 class="Bold">
                {{ $t("message.Welcome Talent") }}
                <img class="titleBg1" src="../images/deco-16.png" />
              </h2>
              <p>{{ $t("message.Talent information") }}</p>
              <!-- <p>{{ $t("message.Explorer") }}</p> -->

              <img class="content-img" src="../images/logo.png" style="width: 50%" alt="talent.gov.hk Logo" />
            </div>
            <div class="page2" v-if="select == 2">
              <h2 class="Bold">
                <span class="titleObj">
                  <span>{{ $t("message.Membership and Terms of Reference") }}</span>
                  <img class="titleBg2" src="../images/deco-21.png" />
                </span>
              </h2>
              <div v-if="this.$store.state.language == 'en_US'">
                <p>
                  The membership of the Human Resources Planning Commission (Commission) is as follows (Term of office - 1 January 2025 to 31 December 2026): 
                  <br />
                  <br /><span class="Bold">Chairman</span> <br />Chief Secretary for Administration
                  <br />
                  <br /><span class="Bold">Non-official Members</span> <br />Ms Chan Ka-yin <br />Mr Stephen Chan Man <br />Ms Cally Chan Shan-shan <br />Mr Kenneth CHAN Yin <br />Miss Vicky Cheung Wai-kar <br />Professor Cheung Stephen Yan-leung <br />Professor Gillian Ann Choa <br />Mr Ivor Chow <br />Mr Eric Fok Kai-shan <br />Ms Mary Huen Wai-yi <br />Mr Lawrence Hung Yu-yun <br />Mr Andy LUI Ho-yin <br />Mr Luo Yong <br />Ms Shalini Mahtani <br />Dr Derrick Pang Yat-bond <br />Ms Anna Thompson <br />Professor Wang Yang <br />Ms Karmen Yeung Ka-yin <br />Mr Terry Yip Man-pan <br />Mr Zhao Lei
                  <br />
                  <br /><span class="Bold">Ex-officio Members</span> <br />Secretary for Commerce and Economic Development <br />Secretary for Constitutional and Mainland Affairs <br />Secretary for
                  Education <br />Secretary for Financial Services and the Treasury <br />Secretary for Health <br />Secretary for Innovation, Technology and Industry <br />Secretary for Labour and
                  Welfare <br />Secretary for Security <br />Commissioner for Census and Statistics <br />Government Economist <br />Chairman, Employees Retraining Board <br />Chairman, Hong Kong
                  Council for Accreditation of Academic and Vocational Qualifications <br />Chairman, Vocational Training Council
                  <br />
                  <br />
                  <br /><span class="Bold">The terms of reference of the Commission are:</span> <br />a. To explore, devise and coordinate strategies and measures to enhance the quality, quantity and competencies of our workforce at various levels as a matter of priority to support and drive Hong Kong’s diversified economic developments and meet rapidly changing social needs;
                  <br />
                  <br />b. to monitor, review and examine the regimes of training and employment support and services to fully unleash the potential of the local workforce, admission of talents and manpower from outside Hong Kong and identify issues requiring action;
                  <br />
                  <br />c. to follow up and refine the Government’s overall population policy; and 
                  <br />
                  <br />d. to engage stakeholders and experts from outside the Government in furthering the work of the Commission.
                </p>
              </div>
              <div v-if="this.$store.state.language == 'zh_HK'">
                <p>
                  人力資源規劃委員會(委員會)的成員名單如下 (任期 - 2025年1月1日至2026年12月31日)：
                  <br />
                  <br /><span class="Bold">主席</span> <br />政務司司長
                  <br />
                  <br /><span class="Bold">非官方委員</span> <br />陳嘉賢 <br />陳文 <br />陳珊珊 <br />陳然 <br />張慧嘉 <br />張仁良教授 <br />蔡敏志教授 <br />周彥邦
                  <br />霍啟山 <br />禤惠儀 <br />孔于人 <br />呂浩延 <br />駱勇 <br />馬夏邐 <br />彭一邦博士 <br />唐安娜
                  <br />汪揚教授 <br />楊嘉燕 <br />葉文斌 <br />趙磊 
                  <br />
                  <br /><span class="Bold">當然委員</span> <br />商務及經濟發展局局長 <br />政制及內地事務局局長 <br />教育局局長 <br />財經事務及庫務局局長 <br />醫務衞生局局長
                  <br />創新科技及工業局局長 <br />勞工及福利局局長 <br />保安局局長 <br />政府統計處處長 <br />政府經濟顧問 <br />僱員再培訓局主席 <br />香港學術及職業資歷評審局主席
                  <br />職業訓練局主席
                  <br />
                  <br />
                  <br /><span class="Bold">委員會的職權範圍如下：</span> <br />(甲) 探討、擬訂和統籌各項策略及措施，以期在不同層面提升本港勞動人口的質量和能力，從而支援和推動香港經濟多元發展，配合不斷轉變的社會需要； 
                  <br />
                  <br />(乙) 監察、檢討和研究有關培訓以及就業支援與服務的制度，以期全面釋放本地勞動人口的潛力和善用從外地輸入的人才及勞工，並辨識須予處理的事宜；
                  <br />
                  <br />(丙) 跟進和優化政府的整體人口政策；以及
                  <br />
                  <br />(丁) 推動持份者和政府以外的專家共同推展委員會的工作。
                </p>
              </div>
              <div v-if="this.$store.state.language == 'zh_CN'">
                <p>
                  人力资源规划委员会(委员会)的成员名单如下 (任期 - 2025年1月1日至2026年12月31日)：
                  <br />
                  <br /><span class="Bold">主席</span> <br />政务司司长
                  <br />
                  <br /><span class="Bold">非官方委员</span> <br />陈嘉贤 <br />陈文 <br />陈珊珊 <br />陈然 <br />张慧嘉 <br />张仁良教授 <br />蔡敏志教授 <br />周彦邦
                  <br />霍启山 <br />禤惠仪 <br />孔于人 <br />吕浩延 <br />骆勇 <br />马夏逦 <br />彭一邦博士 <br />唐安娜
                  <br />汪扬教授 <br />杨嘉燕 <br />叶文斌 <br />赵磊 
                  <br />
                  <br /><span class="Bold">当然委员</span> <br />商务及经济发展局局长 <br />政制及内地事务局局长 <br />教育局局长 <br />财经事务及库务局局长 <br />医务衞生局局长
                  <br />创新科技及工业局局长 <br />劳工及福利局局长 <br />保安局局长 <br />政府统计处处长 <br />政府经济顾问 <br />雇员再培训局主席 <br />香港学术及职业资历评审局主席
                  <br />职业训练局主席
                  <br />
                  <br />
                  <br /><span class="Bold">委员会的职权范围如下：</span> <br />(甲) 探讨丶拟订和统筹各项策略及措施，以期在不同层面提升本港劳动人口的质量和能力，从而支援和推动香港经济多元发展，配合不断转变的社会需要； 
                  <br />
                  <br />(乙) 监察丶检讨和研究有关培训以及就业支援与服务的制度，以期全面释放本地劳动人口的潜力和善用从外地输入的人才及劳工，并辨识须予处理的事宜；
                  <br />
                  <br />(丙) 跟进和优化政府的整体人口政策；以及
                  <br />
                  <br />(丁) 推动持份者和政府以外的专家共同推展委员会的工作。
                </p>
              </div>
            </div>
            <div class="page3" v-if="select == 3">
              <h2 class="Bold">
                {{ $t("message.HRPC Information Centre") }}
                <img class="titleBg3" src="../images/deco-10.png" />
              </h2>

              <div v-for="(itemList, index) in centreList">
                <h4 class="SemiBold" v-if="itemList.links.length != 0">
                  {{ $store.getters.getObject(itemList.langData).name }}
                </h4>
                <div class="row" v-for="(item, index) in itemList.links">
                  <a class="col-sm-10 padLeft-0 padRight-0" v-bind="{ href: $store.getters.getObject(item.langData).link }">{{ $store.getters.getObject(item.langData).title }}</a>
                  <p class="date col-sm-2 padLeft-0 padRight-0">{{ item.informationDate }}</p>
                </div>
              </div>

              <!-- <h4 class="SemiBold" v-if="centreList[0].links.length != 0">{{$t('message.Archive')}}</h4> -->
            </div>
            <div class="page4" v-if="select == 4">
              <h2 class="Bold">
                {{ $t("message.Contact Us") }}
                <img class="titleBg3" src="../images/deco-16.png" />
              </h2>
              <h4 class="SemiBold">{{ $t("message.Human Resources Planning Commission") }}</h4>
              <div class="row textGroup">
                <div>
                  <div class="item-table" style="padding: 5px 0">
                    <div class="tdcell contact-us-info-left" :class="{ 'contact-us-info-left_zh': $store.state.language != 'en_US' }">{{ $t("message.Email:") }}</div>
                    <div class="tdcell"><a href="hrpc@lwb.gov.hk">hrpc@lwb.gov.hk</a></div>
                  </div>
                  <div class="item-table" style="padding: 5px 0">
                    <div class="tdcell contact-us-info-left" :class="{ 'contact-us-info-left_zh': $store.state.language != 'en_US' }">{{ $t("message.Address:") }}</div>
                    <div class="tdcell">{{ $t("message.Human Resources") }}</div>
                  </div>
                  <div class="item-table" style="padding: 5px 0">
                    <div class="tdcell contact-us-info-left" :class="{ 'contact-us-info-left_zh': $store.state.language != 'en_US' }">{{ $t("message.Telephone:") }}</div>
                    <div class="tdcell">3655 5879</div>
                  </div>
                  <div class="item-table" style="padding: 5px 0">
                    <div class="tdcell contact-us-info-left" :class="{ 'contact-us-info-left_zh': $store.state.language != 'en_US' }">{{ $t("message.Fax:") }}</div>
                    <div class="tdcell">2801 6314</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img class="bgImg noSelect" v-if="$store.state.innerWidth > 1320" src="../images/deco-18.png" />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";

export default {
  name: "aboutUs",
  data() {
    return {
      select: 1,
      showMenuGroup: false,
      centreList: [],
      newScrollTop: 0,
      oldScrollTop: 0,
    };
  },
  props: ["logGaEvent"],
  components: {
    Breadcrumbs,
  },
  computed: {
    innerwidth() {
      return this.$store.state.innerWidth;
    },
  },
  created() {},
  methods: {
    checkScroll: function () {
      this.$store.state.innerWidth;
      var st = document.documentElement.scrollTop || document.documentElement.scrollTop;
      var bodyHeight = document.body.style.height.slice(0, -2);

      if (st / document.documentElement.scrollHeight < bodyHeight / window.innerHeight) {
      }
    },
    getCentreList: function (id) {
      let that = this;
      that.api.getInformationCentreList({}, function (data) {
        that.centreList = data.result;
        // window.scrollTo(0,that.$store.state.formData.aboutUsScroll);
      });
    },
    selectEvent: function (num) {
      this.select = num;
      this.showMenuGroup = false;
    },
    openMenuGroup: function () {
      this.showMenuGroup = !this.showMenuGroup;
    },
  },
  mounted() {
    this.$store.state.selectMenu = 0;
    var that = this;
    setTimeout(function () {
      that.$store.state.mate.title = that.$i18n.t("message.About Us") + " - talent.gov.hk - " + that.$i18n.t("message.Default Page Title");
    });
    this.getCentreList();
  },
  watch: {
    // innerwidth (news,old) {
    //   window.resize();
    // },
  },
};
</script>
